import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import IconButton from 'components/ui/Button/IconButton';
import { TrendUpIcon } from 'components/ui/icons/TrendUpIcon';
import { TrophyIcon } from 'components/ui/icons/TrophyIcon';
import headerUrls from 'configs/headerUrls';
import { useRem } from 'hooks/useRem';
import { accessibilityParamsStore, userStore } from 'stores/root';

import s from './LinkButtons.module.scss';

const LinkButtons: React.FC = () => {
  const { isAuthorized } = userStore;
  const { isOpen: isAccessibilityMode } = accessibilityParamsStore;
  const calcRem = useRem();

  const iconSize = calcRem({ desktop: 24, tablet: 20 });

  return (
    <div className={s.root}>
      {isAuthorized && (
        <IconButton
          className={cn(s.root__button, s.root__button_rating, isAccessibilityMode && s.root__button_accessibility)}
          Icon={TrophyIcon}
          iconSize={iconSize}
          element="link"
          to={headerUrls.rating}
        />
      )}
      <IconButton
        className={cn(s.root__button, s.root__button_track, isAccessibilityMode && s.root__button_accessibility)}
        Icon={TrendUpIcon}
        iconSize={iconSize}
        element="link"
        to={headerUrls.track}
      />
    </div>
  );
};

export default observer(LinkButtons);
